function CourseCardSkeleton({ index }) {
  const titleWidth = index % 3 === 1 ? 'w-11/12' : index % 3 === 2 ? 'w-10/12' : 'w-9/12';

  return (
    <article
      className="h-full min-h-[350px] overflow-hidden rounded-card border border-line bg-paper"
      aria-hidden="true"
    >
      <div className="relative aspect-[5/3] w-full shrink-0 overflow-hidden bg-teal-soft">
        <div className="absolute left-3 top-3 h-5 w-[70px] rounded-full bg-skeleton-soft animate-pulse motion-reduce:animate-none" />
        <div className="absolute inset-x-8 top-1/2 h-16 -translate-y-1/2 rounded-input bg-skeleton animate-pulse motion-reduce:animate-none" />
      </div>

      <div className="flex min-h-0 flex-1 flex-col p-4">
        <div className="space-y-2">
          <div className={`h-5 rounded-input bg-skeleton animate-pulse motion-reduce:animate-none ${titleWidth}`} />
          <div className="h-5 w-7/12 rounded-input bg-skeleton animate-pulse motion-reduce:animate-none" />
        </div>

        <div className="mt-4 flex h-5 items-center gap-3">
          <div className="h-1.5 flex-1 rounded-full bg-skeleton animate-pulse motion-reduce:animate-none" />
          <div className="h-3 w-8 rounded-input bg-skeleton animate-pulse motion-reduce:animate-none" />
        </div>

        <div className="mt-auto pt-7">
          <div className="h-8 w-[116px] rounded-full bg-skeleton animate-pulse motion-reduce:animate-none" />
        </div>
      </div>
    </article>
  );
}

// Kept independent of CourseGrid so startup can render the same placeholders
// without downloading the course page, cards or recovery animation first.
export function CourseGridSkeleton({ label = 'Loading courses' }) {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 lg:gap-6 items-stretch"
      data-testid="course-grid-skeleton"
      role="status"
      aria-label={label}
      aria-busy="true"
    >
      <span className="sr-only">{label}…</span>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <CourseCardSkeleton key={i} index={i} />
      ))}
    </div>
  );
}
